import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Flexbox Sidebar"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "flexbox-sidebar"
    }}>{`Flexbox Sidebar`}</h1>
    <p>{`Create a sidebar layout with flexbox that automatically stacks when the container is narrow.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live xray",
        "live": true,
        "xray": true
      }}>{`<div
  sx={{
    display: 'flex',
    flexWrap: 'wrap',
  }}>
  <aside
    sx={{
      flexGrow: 1,
      flexBasis: 'sidebar',
    }}>
    Sidebar
  </aside>
  <main
    sx={{
      flexGrow: 99999,
      flexBasis: 0,
      minWidth: 320,
    }}>
    Main
  </main>
</div>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme
export default {
  sizes: {
    sidebar: 256,
  },
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

export default (props) => (
  <div
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
    }}>
    <aside
      sx={{
        flexGrow: 1,
        flexBasis: 'sidebar',
      }}>
      Sidebar
    </aside>
    <main
      sx={{
        flexGrow: 99999,
        flexBasis: 0,
        minWidth: 320,
      }}>
      {props.children}
    </main>
  </div>
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      